export default "__VITE_PUBLIC_ASSET__f3fb7521__"